<template>
  <div>
    <div class="row" id="scrollID">
      <nav v-if="isUserDetail" id="navbar-example2" class="navbar px-3 flex-column col-lg-2 links-menu">
        <ul class="nav nav-pills flex-column links-list-menu w-100">
          <li class="nav-item" v-for="item in userProfileMenuItems" :key="item.id" @click="activeSideMenuLink(item.key)">
            <a class="nav-link" :href="`#${item.key}`" ref="a"> <i :class="`${item.icon}`"></i>{{ item.name }} </a>
          </li>
        </ul>
      </nav>
      <b-alert class="alert-popUp" :show="dismissCountDown" @dismissed="dismissCountDown = false">
        <div class="d-flex h-100">
          <div style="background-color:#34C38F; width: 30px; border-radius: 0 8px 8px 0"></div>
          <div class="d-flex align-items-center" style="color: #34C38F; padding-right: 20px;">
            با موفقیت ثبت شد
          </div>
        </div>
        <div @click="dismissCountDown = false" style="display: flex;justify-content: end;width: 60%; cursor:pointer">
          <i style="font-size: 30px; color: #34C38F" class="fa fa-times"></i>
        </div>
      </b-alert>
      <div class="section__container" :class="{ 'col-lg-12': !isUserDetail, 'col-lg-10': isUserDetail }" ref="section__container">
          <Toast title="با موفقیت ثبت شد" :submit="true" :showToast="showSubmitToast" />
        <div class="__section" v-for="item in userProfileMenuItems" :key="item.key" ref="section" :id="item.key">
          <UserInformationForm @goUp="needToScroll = $event" @userUpdated="userUpdated($event)" :class="`__section ${item.key}`" v-if="item.key == 'user'" />
          <Table
            v-else
            :tableData="dataTables[item.key]"
            :class="`__section ${item.key}`"
            :tableId="item.key"
            @tableObj="tableObj($event)"
            @modalName="showMsgModal"
            :wannaUpdate="wannaUpdate"
            :noNeedToChangeRoute="dataTables[item.key].data.addRowPage.link == null ? true : false"
          />
        </div>
        <b-modal
          v-model="modalVisible"
          title="پیام جدید"
          no-close-on-esc
          hide-footer
          headerClass=""
          centered
          content-class="DeleteCardModalStyle"
          header-close-variant="dark"
          cancel-title
        >
          <Messages
            :selectLoading="selectLoading"
            :aproveLoading="aproveLoading"
            :messages="messages"
            @closeModal="modalVisible = $event"
            @selectCustomMessage="selectedMessage($event)"
            @typedCustomMessage="addMessage($event)"
          />
        </b-modal>
        <Toast title="کاربر غیرفعال است. برای ارسال پیام باید کاربر را فعال کنید" :error="true" :showToast="showErrorToast" />
      </div>
    </div>
  </div>
</template>

<script>
import Table from '../common/table/simpleTable/index.vue'
import Messages from '../messages/Messages.vue'
import UserInformationForm from './UserInformationForm.vue'
import notificationsDataProvider from '../../services/notifications'
import { userMixins } from '../../utils/mixins'
import userDataProvider from '../../services/user'
import Toast from '../common/Toast.vue'
export default {
  props: {
    menuItems: {
      type: Array,
    },
    isUserDetail: {
      type: Boolean,
      default: true,
    },
    dataTables: [],
    wannaUpdate: {
      type: Boolean,
    },
  },
  components: {
    Table,
    Toast,
    Messages,
    UserInformationForm,
  },
  mixins: [userMixins],
  headerItems: [
    {
      text: 'داشبورد',
      href: '/',
    },
    {
      text: 'جدول تیم تسک',
      active: true,
    },
  ],
  data() {
    return {
      allowSubmit: true,
      selectLoading: false,
      aproveLoading: false,
      showSubmitToast: false,
      showErrorToast: false,
      modalVisible: false,
      messageValue: null,
      messages: [],
      keysArray: [],
      needToScroll: null,
    }
  },
  methods: {
    showMsgModal() {
      userDataProvider
        .getUserDetails({
          peopleId: this.$route.params.id,
        })
        .then(res => {
          if (res.data.data.peopleGlobalDto.isDeactivate) {
            this.showErrorToast = true
          } else {
            this.modalVisible = true
          }
        })
      this.showErrorToast = false
    },
    selectedMessage(messageId) {
      this.selectLoading = true
      if (this.allowSubmit) {
        this.allowSubmit = false
        notificationsDataProvider
          .selectMessage({
            id: messageId,
            peopleId: this.$route.params.id,
          })
          .then(res => {
            this.allowSubmit = true
            this.selectLoading = false
            this.modalVisible = false
            this.tableObj({ tableId: 'chat', page: 1, pageSize: { id: 1, count: 10, value: 'نمایش 10 تایی', isDefault: true } })
            
          })
      }
    },
    addMessage(data) {
      this.aproveLoading = true
      if (this.allowSubmit) {
        this.allowSubmit = false
        notificationsDataProvider
          .addMessage({
            message: data.customTextMessage,
            title: data.customTitle,
            peopleId: this.$route.params.id,
          })
          .then(res => {
            this.allowSubmit = true
            this.aproveLoading = false
            this.modalVisible = false
            this.tableObj({ tableId: 'chat', page: 1, pageSize: { id: 1, count: 10, value: 'نمایش 10 تایی', isDefault: true } })
            
          })
      }
    },
    tableObj(e) {
      this.$emit('tableObj', e)
    },
    userUpdated(e) {
      this.showSubmitToast = true
      this.$emit('userUpdated', e)
      setTimeout(() => {
        this.showSubmitToast = false
      }, 500)
    },
    activeSideMenuLink(data) {
      let findedSection = this.$refs.a.find(el => el.hash === `#${data}`)
      setTimeout(() => {
        for (let i = 0; i < this.$refs.section.length; i++) {
          this.$refs.a[i].classList.remove('__active__link')
        }
        findedSection.classList.add('__active__link')
      }, 700)
      
      
    },
  },
  watch: {
    needToScroll(val) {
      if (val) {
        
        this.$refs.section__container.scrollTop = 0
      }
    },
  },
  mounted() {
    notificationsDataProvider.showMessages().then(res => {
      this.messages = res.data.data
    })
    if (this.isUserDetail) {
      setTimeout(() => {
        let mainNavLinks = this.$refs.a
        this.$refs.section__container.addEventListener('scroll', () => {
          let fromTop = this.$refs.section__container.scrollTop
          mainNavLinks.forEach(link => {
            let section = document.querySelector(link.hash)
            if (section.offsetTop <= fromTop && section.offsetTop + section.offsetHeight > fromTop) {
              link.classList.add('__active__link')
            } else {
              link.classList.remove('__active__link')
            }
          })
        })
      }, 1500)
    }
  },
}
</script>

<style lang="scss" scoped>
.alert-popUp {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  background: white;
  border: none;
  align-items: center;
  min-width: 450px;
  border-radius: 9px;
  height: 90px;
  text-align: right;
  position: fixed;
  z-index: 9999;
  bottom: 50px;
  right: 275px;
}
::v-deep .alert {
  padding: 0;
}
::v-deep .links-list-menu li a.active {
  background-color: none !important;
}
::v-deep #navbar-example2 > .nav {
  position: sticky;
}
a.__active__link {
  color: #f46a6a !important;
  background-color: none !important;
}
.links-menu {
  height: fit-content;
  background-color: white;
  border-radius: 5px;
}
.__section {
  width: 100%;
}
.section__container {
  margin-top: 0;
  height: calc(100vh - 310px);
  overflow-y: auto;
  scroll-behavior: smooth;
}

.section__container::-webkit-scrollbar {
  display: none;
}
.links-list-menu {
  list-style-type: none;
  padding: 0 !important;
  a {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 23px;
    letter-spacing: 0px;
    cursor: pointer;
    padding: 20px 0;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eff2f7;
    transition: 0.2s ease-in-out;
    color: #74788d;
  }
  a:hover {
    color: #f46a6a !important;
  }
  li:last-child {
    a {
      border-bottom: 0 solid #eff2f7 !important;
    }
  }
}

i {
  font-size: 17px;
  margin-left: 10px;
}
.user {
  padding: 30px;
  background: #ffffff;
  box-shadow: 0px 10px 20px rgba(18, 38, 63, 0.0313726);
  border-radius: 8px;
  margin-bottom: 30px;
}
::v-deep .__section .card-body {
  min-height: 290px;
}
::v-deep .modal-dialog {
  max-width: 540px !important;
}
::v-deep .modal-backdrop {
  background-color: rgba(19, 19, 19, 0.9) !important;
}
::v-deep .modal-title {
  font-size: 14px;
  color: #4a4a4a;
}
</style>
